import axios from "axios";
import url, { cdnUrl, globalCdnUrl } from "../utils/url";
import getError from "../utils/getError";

export const adminSendOtp = (data, afterAsync) => {
  axios
    .post(url + `/auth`, data)
    .then((res) => {
      afterAsync(true);
    })
    .catch((err) => {
      console.log(err.response);
      afterAsync(false, getError(err));
    });
};

export const getCustomers = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/customers` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getOrders = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/orders` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getBlogPosts = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/blogs` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCategories = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/categories` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const addCategory = (data, afterPerform) => {
  axios
    .post(url + `/category`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateCategory = (id, data, afterPerform) => {
  axios
    .put(url + `/category/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(getError(err));
      afterPerform(false, getError(err));
    });
};

export const addProduct = (data, afterPerform) => {
  axios
    .post(url + `/product`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addBasicProduct = (data, afterPerform) => {
  axios
    .post(url + `/product/basic`, data)
    .then((res) => {
      afterPerform(res?.data?.data);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateProduct = (id, data, afterPerform) => {
  axios
    .put(url + `/product/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(getError(err));
      afterPerform(false, getError(err));
    });
};

export const getBrands = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/brands` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getProductById = (id, setData) => {
  axios
    .get(url + `/product/${id}`)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getPostById = (id, setData) => {
  axios
    .get(url + `/blog/${id}`)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getProducts = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/products` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const addBrand = (data, afterPerform) => {
  axios
    .post(url + `/brand`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateBrand = (id, data, afterPerform) => {
  axios
    .put(url + `/brand/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(getError(err));
      afterPerform(false, getError(err));
    });
};

export const getBookings = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/bookings` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getBooking = (id, setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/booking/${id}` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getPayments = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/payments` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getReviews = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/reviews` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getPaymentOrderList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/payment/orders/list` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getPurchasingList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/purchase/list` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getDelivery = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/delivery/list` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getDeliveries = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/deliveries` + filters)
    .then((res) => {
      setData(res.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getVendorCounter = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/counter/vendors` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getCustomerCounter = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/counter/customers` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getPayableDetails = (id, type, setData) => {
  axios
    .get(url + `/counter/${type}/payable/${id}`)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getWithdraw = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/withdraw` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getCommission = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/commission/orders/list` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const requestCommissionWithdraw = (data, afterAsync) => {
  axios
    .post(url + `/withdraw`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(null);
    });
};

export const initiateDelivery = (filter, afterAsync) => {
  axios
    .post(url + `/delivery/initiate`, filter)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(null);
    });
};

export const getOrderCartons = (id, afterAsync) => {
  axios
    .get(url + `/shipment/cartons/${id}`)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(null);
    });
};

export const placeCourierBooking = (data, afterAsync) => {
  axios
    .post(url + `/courier`, data)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(null);
    });
};
export const executeDelivery = (filter, afterAsync) => {
  axios
    .post(url + `/delivery/execute`, filter)
    .then((res) => {
      afterAsync(res.data?.result);
    })
    .catch((err) => {
      afterAsync(null);
    });
};
export const getTrackingList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/tracking/list` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getAdmins = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/admins` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getVendors = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/vendors` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getStatusList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/statuses` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getOrderReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/order/monthly` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCustomerReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/customer/monthly` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getProductReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/product/monthly` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getBookingReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/booking/monthly` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getPaymentReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/payment/monthly` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getSegmentReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/segment/monthly` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getOrderProfitReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/profit/order` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getSmsReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/sms/gateways/info` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getCoupons = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/coupons` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getCampaigns = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/campaigns` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getShipmentStatusList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/shipment/statuses` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getPayable = (setData, filter) => {
  axios
    .post(url + `/payment/payable`, filter)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getProfile = (setData) => {
  axios
    .get(url + `/profile`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getMasterInvoice = (id, setData) => {
  axios
    .get(url + `/delivery/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const updateProfile = (data, afterPerform) => {
  axios
    .put(url + `/profile`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const bookingAction = (id, action, data, afterPerform) => {
  axios
    .put(url + `/booking/${action}/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const deleteBooking = (id, afterPerform) => {
  axios
    .delete(url + `/booking/${id}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const confirmPayment = (id, type, data, afterPerform) => {
  axios
    .post(url + `/payment/${type}/${id}`, data)
    .then((res) => {
      afterPerform(res.data);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const reviewPayment = (id, data, afterPerform) => {
  axios
    .put(url + `/payment/${id}/check`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const reviewCustomerReview = (id, data, afterPerform) => {
  axios
    .put(url + `/review/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateTracking = (id, data, afterPerform) => {
  axios
    .put(url + `/order/tracking/${id}`, data)
    .then((res) => {
      afterPerform(id);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const updateShipment = (id, data, afterPerform) => {
  axios
    .put(url + `/shipment/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const deleteTracking = (orderId, trackingId, afterPerform) => {
  axios
    .delete(url + `/order/tracking/${orderId}/${trackingId}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const updateOrderItem = (orderId, itemId, data, afterPerform) => {
  axios
    .put(url + `/order/${orderId}/item/${itemId}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const returnOrderItem = (orderId, itemId, data, afterPerform) => {
  axios
    .put(url + `/order/${orderId}/return/${itemId}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const cancelDelivery = (id, afterPerform) => {
  axios
    .delete(url + `/delivery/${id}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getPaymentTransactions = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/payments` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getShipments = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/shipments` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getShipment = (id, setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/shipment/${id}` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getBanks = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/banks` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getVendor = (id, setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/vendor/${id}` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getMetas = (type, setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/metas${type ? "/" + type : ""}` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const updateMeta = (id, data, afterPerform) => {
  axios
    .put(url + `/meta/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(getError(err));
      afterPerform(false, getError(err));
    });
};

export const getSortingList = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/sorting/list` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCallReport = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/report/call/stats/daily` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getAdminCalls = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/calls` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCampaign = (setData, id) => {
  axios
    .get(url + `/campaign/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getTicket = (setData, id) => {
  axios
    .get(url + `/ticket/${id}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getCampaignCustomers = (campaign_id, type, segment, setData) => {
  axios
    .get(url + `/campaign/customers/${campaign_id}/${type}?segment=${segment}`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const uploadFile = (data, url, afterPerform) => {
  axios
    .post(cdnUrl + url, data)
    .then((res) => {
      afterPerform(res.data);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const uploadImage = (data, url, afterPerform) => {
  axios
    .post(globalCdnUrl + url, data, { headers: { Authorization: null } })
    .then((res) => {
      afterPerform(res.data);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getTickets = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/tickets` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};
export const getChats = (setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/chats` + filters)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getOrder = (setData, id) => {
  axios
    .get(url + `/order/${id}`)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const updateCustomer = (id, data, afterPerform) => {
  axios
    .put(url + `/customer/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addAdmin = (data, afterPerform) => {
  axios
    .post(url + `/admin`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const addBank = (data, afterPerform) => {
  axios
    .post(url + `/bank`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addVendor = (data, afterPerform) => {
  axios
    .post(url + `/vendor`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addTicket = (data, afterPerform) => {
  axios
    .post(url + `/ticket`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const addCustomer = (data, afterPerform) => {
  axios
    .post(url + `/customer`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateTicket = (id, data, afterPerform) => {
  axios
    .put(url + `/ticket/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const updateBank = (id, data, afterPerform) => {
  axios
    .put(url + `/bank/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateVendor = (id, data, afterPerform) => {
  axios
    .put(url + `/vendor/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addTicketMessage = (data, afterPerform) => {
  axios
    .post(url + `/chat`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const initiateCashPayment = (data, afterPerform) => {
  axios
    .post(url + `/payment/initiate/cash`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addCoupon = (data, afterPerform) => {
  axios
    .post(url + `/coupon`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const addCampaign = (data, afterPerform) => {
  axios
    .post(url + `/campaign`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const completeSorting = (id, data, afterPerform) => {
  axios
    .put(url + `/order/sorting/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const removeLogistic = (orderId, logisticId, afterPerform) => {
  axios
    .delete(url + `/order/sorting/${orderId}/${logisticId}`)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const createShipment = (data, afterPerform) => {
  axios
    .post(url + `/shipment`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const createBooking = (data, afterPerform) => {
  axios
    .post(url + `/booking`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateBooking = (id, data, afterPerform) => {
  axios
    .put(url + `/booking/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const addOrderNote = (data, afterPerform) => {
  axios
    .post(url + `/order/${data._id}/note`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(err);
      afterPerform(false, getError(err));
    });
};

export const addOrderPayment = (id, data, afterPerform) => {
  axios
    .post(url + `/order/${id}/payment`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(err);
      afterPerform(false, getError(err));
    });
};

export const addOrderRefund = (id, data, afterPerform) => {
  axios
    .put(url + `/order/refund/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(err);
      afterPerform(false, getError(err));
    });
};

export const addTicketNote = (ticket_id, data, afterPerform) => {
  axios
    .put(url + `/ticket/note/${ticket_id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(err);
      afterPerform(false, getError(err));
    });
};

export const addOrderDiscount = (id, data, afterPerform) => {
  axios
    .put(url + `/order/discount/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(err);
      afterPerform(false, getError(err));
    });
};

export const addAdminCall = (data, afterPerform) => {
  axios
    .post(url + `/call`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      console.log(err);
      afterPerform(false, getError(err));
    });
};
export const purchaseCompleteBD = (data, afterPerform) => {
  axios
    .put(url + `/order/purchase/bd/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const purchaseCompleteCN = (data, afterPerform) => {
  axios
    .put(url + `/order/purchase/cn/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateOrderStatus = (data, afterPerform) => {
  axios
    .put(url + `/order/${data._id}/status`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const updatePayablePercentage = (data, afterPerform) => {
  axios
    .put(url + `/order/payable/${data._id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateAdmin = (id, data, afterPerform) => {
  axios
    .put(url + `/admin/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};
export const updateCoupon = (id, data, afterPerform) => {
  axios
    .put(url + `/coupon/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const updateCampaign = (id, data, afterPerform) => {
  axios
    .put(url + `/campaign/${id}`, data)
    .then((res) => {
      afterPerform(true);
    })
    .catch((err) => {
      afterPerform(false, getError(err));
    });
};

export const getReport = (setData) => {
  axios
    .get(url + `/report/basicsummary`)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getBookingStats = (setData) => {
  axios
    .get(url + `/report/stats/bookingstatus`)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getOrderStats = (setData) => {
  axios
    .get(url + `/report/orderstatus/stats`)
    .then((res) => {
      setData(res.data?.result);
    })
    .catch((err) => {
      setData(null);
    });
};

export const getData = (path, setData, filter) => {
  let filters = filter ? "?" + new URLSearchParams(filter).toString() : "";
  axios
    .get(url + `/${path}` + filters)
    .then((res) => {
      setData(res.data?.data);
    })
    .catch((err) => {
      setData(null);
    });
};

export const addData = (path, data, afterPerform) => {
  axios
    .post(url + `/${path}`, data)
    .then((res) => {
      let successMsg =
        res.data?.data?.message || `${path} created successfully`;
      afterPerform(true, successMsg);
    })
    .catch((err) => {
      let errMsg = getError(err) || `Failed to create ${path}`;
      afterPerform(false, errMsg);
    });
};

export const updateData = (path, id, data, afterPerform) => {
  axios
    .put(url + `/${path}/${id}`, data)
    .then((res) => {
      let successMsg =
        res.data?.data?.message || `${path} updated successfully`;
      afterPerform(true, successMsg);
    })
    .catch((err) => {
      let errMsg = getError(err) || `Failed to update ${path}`;
      afterPerform(false, errMsg);
    });
};
export const deleteData = (path, id, afterPerform, data) => {
  axios
    .delete(url + `/${path}/${id}`, data)
    .then((res) => {
      let successMsg =
        res.data?.data?.message || `${path} deleted successfully`;
      afterPerform(true, successMsg);
    })
    .catch((err) => {
      let errMsg = getError(err) || `Failed to delete ${path}`;
      afterPerform(false, errMsg);
    });
};
